export const postConfig = (data) => {
  return {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    redirect: 'follow',
    body: JSON.stringify(data),
  };
};